import { useSettingsStore } from "@/store/settings-store";
import { storeToRefs } from "pinia";
import { refProp } from "@/composables/reactive";
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";

export const useDeviceKind = () => {
    const settingsStore = useSettingsStore();
    const { settings } = storeToRefs(settingsStore);
    const deviceKindOverride = refProp(settings, "deviceKindOverride");

    const { width } = useWindowSize();

    return computed(() => {
        return deviceKindOverride.value
            ? deviceKindOverride.value
            : width.value < 700
              ? "smartphone"
              : "desktop";
    });
};
